(function () {
  "use strict";

  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    window.gtag("consent", "default", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });

    try {
      window.uetq = window.uetq || [];
      window.uetq.push("consent", "default", { ad_storage: "denied" });
    } catch (err) {
      console.warn("Unable to set default Bing consent:", err);
    }

    const deriveFlags = categoryStatus => {
      const analyticsAllowed = Boolean(categoryStatus.Analytics);
      const functionalAllowed = Boolean(categoryStatus.Functional);
      const marketingAllowed = Boolean(categoryStatus.Marketing || categoryStatus.Advertising);

      return { analyticsAllowed, functionalAllowed, marketingAllowed };
    };

    const applyGoogleConsent = (analyticsAllowed, marketingAllowed) => {
      if (typeof window.gtag !== "function") return;

      window.gtag("consent", "update", {
        analytics_storage: analyticsAllowed ? "granted" : "denied",
        ad_storage: marketingAllowed ? "granted" : "denied",
        ad_user_data: marketingAllowed ? "granted" : "denied",
        ad_personalization: marketingAllowed ? "granted" : "denied",
      });
    };

    const applyVWOConsent = analyticsAllowed => {
      try {
        window._vwo_q = window._vwo_q || [];

        if (analyticsAllowed) {
          window._vwo_pc_custom = {
            a: 1,
            t: 1,
          };

          window._vwo_q.push(["track.consent.granted"]);
          console.log("VWO tracking enabled (analyticsAllowed = true)");
        } else {
          window._vwo_q.push(["track.consent.denied"]);
          window._vwo_q.push(["optOutVisitor"]);
          console.log("VWO tracking disabled (analyticsAllowed = false)");
        }
      } catch (err) {
        console.error("Error applying VWO consent:", err);
      }
    };

    const applyFacebookConsent = marketingAllowed => {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "secuvy_facebook_consent_update",
          secuvy_facebook_marketing: marketingAllowed ? "granted" : "denied",
        });
      } catch (err) {
        console.error("Error applying Facebook consent:", err);
      }
    };

    const applyBingConsent = marketingAllowed => {
      try {
        window.uetq = window.uetq || [];
        window.uetq.push("consent", "update", {
          ad_storage: marketingAllowed ? "granted" : "denied",
        });

        console.log("Bing UET ad_storage consent:", marketingAllowed ? "granted" : "denied");
      } catch (err) {
        console.error("Error applying Bing consent:", err);
      }
    };

    const applyPinterestConsent = marketingAllowed => {
      try {
        window.pintrk =
          window.pintrk ||
          function () {
            window.pintrk.queue.push(arguments);
          };

        window.pintrk.queue = window.pintrk.queue || [];

        window.pintrk("setconsent", Boolean(marketingAllowed));

        console.log("Pinterest consent queued:", marketingAllowed ? "granted" : "denied");
      } catch (err) {
        console.error("Error applying Pinterest consent:", err);
      }
    };

    const applyKlaviyoIdentify = marketingAllowed => {
      try {
        if (!marketingAllowed) {
          window.__zinusKlaviyoIdentified = false;
          return;
        }

        if (window.__zinusKlaviyoIdentified) return;

        const payloadEl = document.getElementById("zinus-klaviyo-identify-payload");
        if (!payloadEl) return;

        let email = "";
        try {
          email = JSON.parse((payloadEl.textContent || "").trim());
        } catch (parseErr) {
          return;
        }

        if (!email || typeof email !== "string") return;

        window._learnq = window._learnq || [];
        window._learnq.push(["identify", { "$email": email }]);
        window.__zinusKlaviyoIdentified = true;
      } catch (err) {
        console.error("Error applying Klaviyo identify:", err);
      }
    };

    const bvTrackingAllowed = () => {
      if (window.__secuvyConsent && typeof window.__secuvyConsent.analytics === "boolean") {
        return window.__secuvyConsent.analytics;
      }

      try {
        const raw = localStorage.getItem("secuvy");
        if (!raw) return false;

        const parsed = JSON.parse(decodeURIComponent(raw));
        if (typeof parsed.Analytics === "boolean") return parsed.Analytics;
        if (typeof parsed.analytics === "boolean") return parsed.analytics;
      } catch (err) {}

      return false;
    };

    const applyBazaarvoiceConsent = analyticsAllowed => {
      try {
        function applyWhenReady() {
          if (!window.BV || !window.BV.cookieConsent) {
            setTimeout(applyWhenReady, 300);
            return;
          }

          window.BV.cookieConsent.setConsent({
            BVBRANDID: Boolean(analyticsAllowed),
            BVBRANDSID: Boolean(analyticsAllowed),
          });

          console.log(
            "Bazaarvoice tracking consent:",
            analyticsAllowed ? "granted" : "denied"
          );
        }

        applyWhenReady();
      } catch (err) {
        console.error("Error applying Bazaarvoice consent:", err);
      }
    };

    window.bvCallback = function () {
      applyBazaarvoiceConsent(bvTrackingAllowed());
    };

    const applyShopifyConsent = (analyticsAllowed, marketingAllowed, functionalAllowed) => {
      try {
        const shopify = window.Shopify;
        const customerPrivacy = shopify && shopify.customerPrivacy;

        if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== "function") {
          return;
        }

        customerPrivacy.setTrackingConsent(
          {
            analytics: analyticsAllowed,
            marketing: marketingAllowed,
            preferences: functionalAllowed,
            sale_of_data: marketingAllowed,
          },
          () => {
            console.log("Shopify tracking consent updated");
          },
        );
      } catch (err) {
        console.error("Error applying Shopify consent:", err);
      }
    };

    window.addEventListener("SecuvyConsentStatus", ev => {
      try {
        const categoryStatus = (ev.detail && ev.detail.categoryStatus) || {};
        const { analyticsAllowed, marketingAllowed, functionalAllowed } =
          deriveFlags(categoryStatus);

        window.__secuvyConsent = {
          analytics: analyticsAllowed,
          functional: functionalAllowed,
          marketing: marketingAllowed,
        };

        applyGoogleConsent(analyticsAllowed, marketingAllowed);
        applyVWOConsent(analyticsAllowed);
        applyFacebookConsent(marketingAllowed);
        applyBingConsent(marketingAllowed);
        applyPinterestConsent(marketingAllowed);
        applyShopifyConsent(analyticsAllowed, marketingAllowed, functionalAllowed);
        applyKlaviyoIdentify(marketingAllowed);

        // Bazaarvoice: only BVBRANDID and BVBRANDSID are controlled by consent.
        // Review widgets should still load without consent.
        applyBazaarvoiceConsent(analyticsAllowed);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "secuvy_consent_update",
          secuvy_analytics_consent: analyticsAllowed ? "granted" : "denied",
          secuvy_marketing_consent: marketingAllowed ? "granted" : "denied",
        });
      } catch (err) {
        console.error("Error handling SecuvyConsentStatus:", err);
      }
    });
  } catch (err) {
    console.error("Error initializing vendor consent bridge:", err);
  }
})();